import React from "react";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CustomButton from "../../../assets/components/CustomButton";

const StartWithKeyDialog = ({ open, handleClose, handleSubmit }) => {
  const content = (
    <div className="w-100 text-center">
      <p className={classes.smallTitle}>
        شروع به ازای 3 کلید. آیا مطمئن هستید؟
      </p>
      <div className="w-100 mt-4 row p-0 m-0">
        <div className="col-6 d-flex justify-content-center">
          <CustomButton
            clickHandler={handleSubmit}
            text={"بله"}
          />
        </div>
        <div className="col-6 d-flex justify-content-center">
          <CustomButton
            clickHandler={handleClose}
            color={"secondary"}
            text={"لغو"}
          />
        </div>
      </div>
    </div>
  );

  return (
    <CustomModal
      open={open}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={content}
    />
  );
};

export default StartWithKeyDialog;
